<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 24 24"
		:fill="filled ? 'currentColor' : 'none'"
		:stroke="filled ? 'none' : 'currentColor'"
		:stroke-width="strokeWidth"
		stroke-linecap="round"
		stroke-linejoin="round"
		aria-hidden="true"
		focusable="false"
		class="flex-none"
	>
		<path :d="path" />
	</svg>
</template>

<script>
// Stroke icons drawn for the phone app (24px grid). Filled ones are listed in FILLED.
const ICONS = {
	search: 'M11 4a7 7 0 1 0 0 14 7 7 0 1 0 0-14zM20 20l-4-4',
	back: 'm15 18-6-6 6-6',
	close: 'M6 6l12 12M18 6 6 18',
	plus: 'M12 5v14M5 12h14',
	minus: 'M5 12h14',
	home: 'M3 10.5 12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z',
	shop: 'M4 4h6.5v6.5H4zM13.5 4H20v6.5h-6.5zM4 13.5h6.5V20H4zM13.5 13.5H20V20h-6.5z',
	kits: 'M21 8 12 3 3 8v8l9 5 9-5zM3 8l9 5 9-5M12 13v8M7.5 5.5l9 5',
	bag: 'M5 8h14l-1 12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zM9 8V6a3 3 0 0 1 6 0v2',
	menu: 'M4 7h16M4 12h16M4 17h16',
	chevronRight: 'm9 6 6 6-6 6',
	chevronDown: 'm6 9 6 6 6-6',
	chevronUp: 'm6 15 6-6 6 6',
	heart: 'M12 20s-7.5-4.6-9.2-9.3C1.6 7.4 3.9 4.5 7 4.5c2.1 0 3.6 1.2 5 3 1.4-1.8 2.9-3 5-3 3.1 0 5.4 2.9 4.2 6.2C19.5 15.4 12 20 12 20z',
	truck: 'M3 6h11v10H3zM14 9h4l3 3v4h-7M7 16.5a2 2 0 1 0 0 .01M17 16.5a2 2 0 1 0 0 .01',
	lock: 'M5 11h14v10H5zM8 11V7a4 4 0 0 1 8 0v4',
	check: 'm5 12 5 5 9-10',
	filter: 'M4 6h9M17 6h3M4 12h3M11 12h9M4 18h11M19 18h1M15 4v4M9 10v4M17 16v4',
	sort: 'M7 4v16M3.5 7.5 7 4l3.5 3.5M17 20V4M13.5 16.5 17 20l3.5-3.5',
	tag: 'M3 12V4h8l10 10-8 8zM7.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 1 0 0-3z',
	percent: 'M19 5 5 19M7 5a2 2 0 1 0 0 4 2 2 0 1 0 0-4zM17 15a2 2 0 1 0 0 4 2 2 0 1 0 0-4z',
	receipt: 'M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8h6M9 12h6M9 16h3',
	pin: 'M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21zM12 7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 1 0 0-5z',
	clock: 'M12 3a9 9 0 1 0 0 18 9 9 0 1 0 0-18zM12 7v5l3 2',
	user: 'M12 4a4 4 0 1 0 0 8 4 4 0 1 0 0-8zM4 21a8 8 0 0 1 16 0',
	gift: 'M3 7h18v12H3zM3 11h18M8 7v12',
	clipboard: 'M9 3h6v3H9zM7 4.5H5V21h14V4.5h-2M9 13l2 2 4-4',
	help: 'M12 3a9 9 0 1 0 0 18 9 9 0 1 0 0-18zM9.5 9.2a2.6 2.6 0 0 1 5 1c0 1.8-2.5 2.2-2.5 3.8M12 17.2v.1',
	chat: 'M21 11.5a8.5 8.5 0 0 1-12.6 7.4L3 20l1.2-4.9A8.5 8.5 0 1 1 21 11.5z',
	returns: 'M4 12a8 8 0 1 0 2.5-5.8L4 8.5M4 4v4.5h4.5',
	faq: 'M4 5h16v11H9l-5 4zM8 9h8M8 12h5',
	info: 'M12 3a9 9 0 1 0 0 18 9 9 0 1 0 0-18zM12 11v6M12 7.5v.1',
	book: 'M3 5h6a3 3 0 0 1 3 3v12a2.5 2.5 0 0 0-2.5-2.5H3zM21 5h-6a3 3 0 0 0-3 3v12a2.5 2.5 0 0 1 2.5-2.5H21z',
	phone: 'M7 3h10v18H7zM11 18h2',
	mail: 'M3 6h18v12H3zM3 7l9 6 9-6',
	bell: 'M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15zM10 20.5a2 2 0 0 0 4 0',
	moon: 'M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z',
	file: 'M7 3h7l5 5v13H7zM14 3v5h5M10 13h6M10 17h6',
	shield: 'M12 3l8 3v6c0 4.5-3.4 8-8 9-4.6-1-8-4.5-8-9V6z',
	ticket: 'M3 6h18v4a2 2 0 0 0 0 4v4H3v-4a2 2 0 0 0 0-4zM14 6v12',
	map: 'M9 4 3 6v14l6-2 6 2 6-2V4l-6 2zM9 4v14M15 6v14',
	logout: 'M15 4h4v16h-4M10 8l-4 4 4 4M6 12h10',
	refresh: 'M4 12a8 8 0 0 1 14-5.3L20 9M20 4v5h-5M20 12a8 8 0 0 1-14 5.3L4 15M4 20v-5h5',
	download: 'M12 4v11M7 10l5 5 5-5M5 20h14',
	external: 'M7 17 17 7M8 7h9v9',
	share: 'M12 3v12M7 8l5-5 5 5M5 14v6h14v-6',
	eye: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12zM12 9a3 3 0 1 0 0 6 3 3 0 1 0 0-6z',
	edit: 'M4 20h4L19 9l-4-4L4 16zM13.5 6.5l4 4',
	trash: 'M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13',
	card: 'M3 6h18v12H3zM3 10h18M7 15h3',
	bank: 'M3 10h18M5 10v8M9.5 10v8M14.5 10v8M19 10v8M3 20h18M12 3l9 5H3z',
	sun: 'M12 8a4 4 0 1 0 0 8 4 4 0 1 0 0-8zM12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4',
	sparkle: 'M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z',
	alert: 'M12 3 2 20h20zM12 9v5M12 17v.1',
	box: 'M21 8 12 3 3 8v8l9 5 9-5zM3 8l9 5 9-5M12 13v8',
	star: 'M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8L3.5 9.7l5.9-.9z',
	more: 'M5 10.2a1.8 1.8 0 1 0 0 3.6 1.8 1.8 0 1 0 0-3.6zM12 10.2a1.8 1.8 0 1 0 0 3.6 1.8 1.8 0 1 0 0-3.6zM19 10.2a1.8 1.8 0 1 0 0 3.6 1.8 1.8 0 1 0 0-3.6z',
	play: 'M7 4.5v15a1 1 0 0 0 1.5.86l12-7.5a1 1 0 0 0 0-1.72l-12-7.5A1 1 0 0 0 7 4.5z',
	heartFilled: 'M12 20s-7.5-4.6-9.2-9.3C1.6 7.4 3.9 4.5 7 4.5c2.1 0 3.6 1.2 5 3 1.4-1.8 2.9-3 5-3 3.1 0 5.4 2.9 4.2 6.2C19.5 15.4 12 20 12 20z',
}

const FILLED = ['star', 'more', 'play', 'heartFilled']

export default {
	props: {
		name: { type: String, required: true },
		size: { type: [Number, String], default: 24 },
		strokeWidth: { type: [Number, String], default: 1.8 },
	},
	computed: {
		path() {
			return ICONS[this.name] || ''
		},
		filled() {
			return FILLED.includes(this.name)
		},
	},
}
</script>
